if (!window.__tepQuickViewBound) {
  window.__tepQuickViewBound = true;

  const reinitJudgeMe = (container) => {
    if (!container) return;
    if (window.jdgm && window.jdgm.customWidgetsLoader) {
      window.jdgm.customWidgetsLoader.loadFromParent(container);
    }
  };

  const setCarouselIndex = (carousel, index) => {
    if (!carousel) return;
    const slides = carousel.querySelectorAll('[data-quick-view-slide]');
    const count = slides.length;
    if (!count) return;
    const nextIndex = ((index % count) + count) % count;
    carousel.dataset.index = String(nextIndex);
    const track = carousel.querySelector('.quick-view-images__track');
    if (track) track.style.transform = `translateX(-${nextIndex * 100}%)`;
    carousel.querySelectorAll('[data-quick-view-dot]').forEach((dot, dotIndex) => {
      dot.classList.toggle('is-active', dotIndex === nextIndex);
    });
  };

  const goCarousel = (carousel, delta) => {
    if (!carousel) return;
    const current = parseInt(carousel.dataset.index, 10) || 0;
    setCarouselIndex(carousel, current + delta);
  };

  const showVariantMedia = (dialog, mediaId) => {
    if (!dialog || !mediaId) return;
    const carousel = dialog.querySelector('[data-quick-view-carousel]');
    if (!carousel) return;
    const slides = Array.from(carousel.querySelectorAll('[data-quick-view-slide]'));
    const index = slides.findIndex((slide) => slide.getAttribute('data-media-id') === mediaId);
    if (index >= 0) setCarouselIndex(carousel, index);
  };

  const openDialog = (dialog) => {
    if (!dialog || typeof dialog.showModal !== 'function') return;
    if (!dialog.open) dialog.showModal();
    setCarouselIndex(dialog.querySelector('[data-quick-view-carousel]'), 0);
    reinitJudgeMe(dialog);
  };

  const closeDialog = (dialog) => {
    if (dialog && dialog.open) dialog.close();
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-quick-view-trigger]');
    if (trigger) {
      event.preventDefault();
      const dialog = document.getElementById(trigger.getAttribute('data-quick-view-target'));
      openDialog(dialog);
      return;
    }

    const closeBtn = event.target.closest('[data-quick-view-close]');
    if (closeBtn) {
      closeDialog(closeBtn.closest('dialog'));
      return;
    }

    const carouselPrev = event.target.closest('[data-quick-view-carousel-prev]');
    if (carouselPrev) {
      event.preventDefault();
      goCarousel(carouselPrev.closest('[data-quick-view-carousel]'), -1);
      return;
    }

    const carouselNext = event.target.closest('[data-quick-view-carousel-next]');
    if (carouselNext) {
      event.preventDefault();
      goCarousel(carouselNext.closest('[data-quick-view-carousel]'), 1);
      return;
    }

    const carouselDot = event.target.closest('[data-quick-view-dot]');
    if (carouselDot) {
      event.preventDefault();
      const index = parseInt(carouselDot.dataset.index, 10) || 0;
      setCarouselIndex(carouselDot.closest('[data-quick-view-carousel]'), index);
      return;
    }

    const variantBtn = event.target.closest('[data-quick-view-variant]');
    if (variantBtn) {
      const dialog = variantBtn.closest('dialog');
      if (!dialog) return;
      dialog.querySelectorAll('[data-quick-view-variant]').forEach((btn) => {
        btn.classList.toggle('is-selected', btn === variantBtn);
      });
      const idInput = dialog.querySelector('input.product-variant-id, input[name="id"]');
      if (idInput) {
        idInput.value = variantBtn.dataset.variantId;
        idInput.disabled = variantBtn.dataset.variantAvailable !== 'true';
      }
      const priceEl = dialog.querySelector('[data-quick-view-price]');
      if (priceEl) {
        const compare = variantBtn.dataset.variantCompare;
        const current = variantBtn.dataset.variantPrice;
        priceEl.innerHTML = `${
          compare ? `<s class="quick-view-price__compare">${compare}</s>` : ''
        }<span class="quick-view-price__current">${current}</span>`;
      }
      showVariantMedia(dialog, variantBtn.dataset.mediaId);
      const submit = dialog.querySelector('[name="add"]');
      if (submit) {
        const available = variantBtn.dataset.variantAvailable === 'true';
        submit.disabled = !available;
        const label = submit.querySelector('span:not(.loading__spinner)');
        if (label && window.variantStrings) {
          label.textContent = available
            ? window.variantStrings.addToCart
            : window.variantStrings.soldOut || label.textContent;
        }
      }
      return;
    }

    const qtyBtn = event.target.closest('[data-quick-view-qty]');
    if (qtyBtn) {
      const wrap = qtyBtn.closest('.quick-view-quantity');
      const input = wrap && wrap.querySelector('[data-quick-view-qty-input]');
      if (!input) return;
      const current = parseInt(input.value, 10) || 1;
      const min = parseInt(input.min, 10) || 1;
      if (qtyBtn.dataset.quickViewQty === 'minus') {
        input.value = Math.max(min, current - 1);
      } else {
        input.value = current + 1;
      }
    }
  });

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof HTMLDialogElement)) return;
    if (!event.target.matches('[data-quick-view-dialog]')) return;
    const rect = event.target.getBoundingClientRect();
    const inside =
      event.clientX >= rect.left &&
      event.clientX <= rect.right &&
      event.clientY >= rect.top &&
      event.clientY <= rect.bottom;
    if (!inside) event.target.close();
  });
}
